//영업기회 및 영업기회 관리
const pubSalesOpportunityRouter = [
   
    /* 화면명 : 영업기회 등록 : MSR_SO_001  */
    {
        path: "/publish/sr/MSR_SO_001", 
        name : 'PUB_MSR_SO_001',
        component: () => import('@/views/publish/sr/MSR_SO_001.vue')
    },

    /* 화면명 : 영업기회 조회/수정  : MSR_SO_002  */
    {
        path: "/publish/sr/MSR_SO_002", 
        name : 'PUB_MSR_SO_002',
        component: () => import('@/views/publish/sr/MSR_SO_002.vue')
    },

    /* 화면명 : 영업기회 조회_STAGE   : MSR_SO_003  */
    {
        path: "/publish/sr/MSR_SO_003", 
        name : 'PUB_MSR_SO_003',
        component: () => import('@/views/publish/sr/MSR_SO_003.vue')
    },

    /* 화면명 : 영업기회 수정  : MSR_SO_004  */
    {
        path: "/publish/sr/MSR_SO_004", 
        name : 'PUB_MSR_SO_004',
        component: () => import('@/views/publish/sr/MSR_SO_004.vue')
    },

    /* 화면명 : 영업기회 알람등록 : MSM_SA_001  */
    {
        path: "/publish/sm/MSM_SA_001", 
        name : 'PUB_MSM_SA_001',
        component: () => import('@/views/publish/sm/MSM_SA_001.vue')
    },

    /* 화면명 : 영업기회 알람 조회/수정 : MSM_SA_002  */
    {
        path: "/publish/sm/MSM_SA_002", 
        name : 'PUB_MSM_SA_002',
        component: () => import('@/views/publish/sm/MSM_SA_002.vue')
    },

    /* 화면명 : 영업기회 설정_제외 : MSM_SA_003  */
    {
        path: "/publish/sm/MSM_SA_003", 
        name : 'PUB_MSM_SA_003',
        component: () => import('@/views/publish/sm/MSM_SA_003.vue')
    },
 
    /* 화면명 : 리드등록 : MSM_SA_004  */
    {
        path: "/publish/sm/MSM_SA_004", 
        name : 'PUB_MSM_SA_004',
        component: () => import('@/views/publish/sm/MSM_SA_004.vue')
    },
        
    /* 화면명 : 리드 조회/수정 : MSM_SA_005  */
        {
        path: "/publish/sm/MSM_SA_005", 
        name : 'PUB_MSM_SA_005',
        component: () => import('@/views/publish/sm/MSM_SA_005.vue')
        },

    /* 화면명 : 리드 수정 : MSM_SA_006  */
        {
            path: "/publish/sm/MSM_SA_006", 
            name : 'PUB_MSM_SA_006',
            component: () => import('@/views/publish/sm/MSM_SA_006.vue')
        },

    /* 화면명 : 이벤트 등록 : MSM_SA_007  */
        {
            path: "/publish/sm/MSM_SA_007", 
            name : 'PUB_MSM_SA_007',
            component: () => import('@/views/publish/sm/MSM_SA_007.vue')
        },

    /* 화면명 : 이벤트 조회/수정  : MSM_SA_008  */
    {
        path: "/publish/sm/MSM_SA_008", 
        name : 'PUB_MSM_SA_008',
        component: () => import('@/views/publish/sm/MSM_SA_008.vue')
    },

    /* 화면명 : 이벤트 조회/수정  : MSM_SA_009  */
    {
        path: "/publish/sm/MSM_SA_009", 
        name : 'PUB_MSM_SA_009',
        component: () => import('@/views/publish/sm/MSM_SA_009.vue')
    }

 

        // redirect : '/sm/list'
        /*children : [
            {
                //ex ) 화면 : 영업기회 조회 list & stage
                path : '/list',
                name : 'smList',
                component: () => import('@/views/sm/List.vue')  ,
            }
        ]*/
    

]
export {pubSalesOpportunityRouter}
